import { Combobox, Stack, Typography } from "@altimateai/lego";
import { CATEGORIES } from "../helpers";

interface Props {
  selectedCategories: string[];
  onCategoriesChange: (categories: string[]) => void;
}

const categoryOptions = CATEGORIES.map(c => ({ value: c, label: c }));

const CategorySelector = ({ selectedCategories, onCategoriesChange }: Props) => {
  return (
    <Stack direction="row" align="center" gap="md">
      <Typography className="al-m-0">Categories:</Typography>
      <Combobox
        options={categoryOptions}
        value={selectedCategories}
        onChange={onCategoriesChange}
        multiSelect
        placeholder="All Categories"
        showClearButton
        buttonProps={{
          size: "sm",
          className: "al-w-56",
          "aria-label": "Select categories",
        }}
      />
    </Stack>
  );
};

export default CategorySelector;
